import React, { useMemo } from 'react';
import { routes } from 'routes/routes';
import { StateModel } from '../redux/reducers';
import { useSelector } from 'react-redux';
import { isAuthorized } from 'helpers/routesHelpers';
import { Navigate, useLocation } from 'react-router-dom';
import { useSessionTimeoutWatcher } from 'hooks/useSessionTimeoutWatcher';
import { StateModel as AuthStateModel } from 'redux/reducers/auth';
import { StateModel as SettingsStateModel } from 'redux/reducers/settings';
import { StateModel as UserAccessStateModel } from 'redux/reducers/userAccess';

const withAccessCheckForRoute = () => (Component: any) => {
  const WithAccessCheckForRoute = () => {
    const location = useLocation();
    const { permissions } = useSelector<StateModel, UserAccessStateModel>(
      (state) => state.userAccess,
    );
    const { layoutVariant } = useSelector<StateModel, SettingsStateModel>(
      (state) => state.settings,
    );

    const { profileData } = useSelector<StateModel, AuthStateModel>(
      (state) => state.auth,
    );

    useSessionTimeoutWatcher({
      sessionDuration: profileData?.sessionDuration ?? 0,
    });

    const { status, redirectPath } = isAuthorized(
      location.pathname,
      layoutVariant,
      permissions,
      routes,
    );

    const node = useMemo(() => {
      return status ? <Component /> : <Navigate to={redirectPath} />;
    }, [status, redirectPath]);

    return node;
  };

  return WithAccessCheckForRoute;
};

export default withAccessCheckForRoute;
